
import on_domready from "domready"
import $ from "jquery"
import "timeago"


// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
($ as any).timeago.settings.allowFuture = true;
($ as any).timeago.settings.cutoff = 1000 * 60 * 60 * 24 * 31
const lang = $("html").attr("lang")

if (lang === "zh-TW") {
  void import(
    "timeago/locales/jquery.timeago.zh-TW"
  )
  .then(() => {
    // Update rendered text
    initAllMatchingElements("[data-time-ago]", true)
  })
}
else if (lang === "zh-CN") {
  void import(
    "timeago/locales/jquery.timeago.zh-CN"
  )
  .then(() => {
    // Update rendered text
    initAllMatchingElements("[data-time-ago]", true)
  })
}
else {
  // Should this even be loaded since default is en?
  void import(
    "timeago/locales/jquery.timeago.en"
  )
  .then(() => {
    // Update rendered text
    initAllMatchingElements("[data-time-ago]", true)
  })
}
/* eslint-enable global-require */


const INIT_DONE_CLASS_NAME = "js--jquery-timeago-init-done"

function initAllMatchingElements(selector_or_el: string | JQuery = "[data-time-ago]", force: boolean = false) {
  $(selector_or_el).each((_idx, el) => {
    setTimeout(() => {
      const $el = $(el)
      if ($el.hasClass(INIT_DONE_CLASS_NAME) && !force) {
        return
      }

      $el.addClass(INIT_DONE_CLASS_NAME);
      ($el as any).timeago()
    })
  })
}

const onLoad = () => {
  on_domready(() => {
    initAllMatchingElements("[data-time-ago]")

    // TODO: Move to page specific scripts later
    // For some reason only the jQuery instance on window works
    $(document).on("ajaxSuccess", () => {
      setTimeout(() => {
        initAllMatchingElements("[data-time-ago]")
      }, 1000)
    })
  })
}


export default {
  onLoad,
  initAllMatchingElements,
}
